import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { KONTAKT, KONTAKT_LANK } from "../../lib/config";
import { Ikon } from "../Ikon";
import { Marke } from "../Marke";

const LANKAR: [string, string][] = [
  ["sa-fungerar-det", "Så fungerar det"],
  ["piloten", "Piloten"],
  ["inlarning", "Inlärning"],
  ["regelchatt", "Regelchatt"],
  ["sakerhet", "Säkerhet"],
];

// Markerar menylänken för den sektion som syns, så att besökaren ser var på sidan hen är.
function useAktivSektion() {
  const [aktiv, setAktiv] = useState<string | null>(null);
  useEffect(() => {
    if (typeof IntersectionObserver === "undefined") return;
    const els = LANKAR.map(([id]) => document.getElementById(id)).filter((e): e is HTMLElement => !!e);
    const synliga = new Set<string>();
    const io = new IntersectionObserver((poster) => {
      poster.forEach((p) => (p.isIntersecting ? synliga.add(p.target.id) : synliga.delete(p.target.id)));
      setAktiv(LANKAR.map(([id]) => id).find((id) => synliga.has(id)) ?? null);
    }, { rootMargin: "-40% 0px -55% 0px" });
    els.forEach((e) => io.observe(e));
    return () => io.disconnect();
  }, []);
  return aktiv;
}

export function Toppfalt() {
  const aktiv = useAktivSektion();
  return (
    <header className="top">
      <div className="wrap">
        <Marke />
        <nav className="nav" aria-label="Huvudmeny">
          {LANKAR.map(([id, namn]) => (
            <a key={id} className="l" href={"#" + id} aria-current={aktiv === id ? "location" : undefined}>{namn}</a>
          ))}
          <Link className="l login" to="/logga-in">Logga in</Link>
          {KONTAKT ? <a className="btn primary sm" href={KONTAKT_LANK}>Boka en genomgång <Ikon namn="arrow" /></a> : null}
        </nav>
      </div>
      <span className="lasforlopp" aria-hidden="true" />
    </header>
  );
}
